import { createFileRoute } from "@tanstack/react-router";
import { footprintListQueryOptions } from "~/features/footprint/api";
import { myProfileQueryOptions } from "~/features/myProfile/api";
import { MyProfileTemplate } from "~/features/myProfile/MyProfileTemplate";

export const Route = createFileRoute("/_authenticated/profile/")({
  loader: ({ context: { queryClient } }) =>
    Promise.all([
      queryClient.ensureQueryData(myProfileQueryOptions),
      queryClient.ensureQueryData(footprintListQueryOptions),
    ]),
  component: MyProfileTemplate,
});
